import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Rooms from "./components/Rooms";
import Amenities from "./components/Amenities";
import HouseRules from "./components/HouseRules";
import Gallery from "./components/Gallery";
import Location from "./components/Location";
import Contact from "./components/Contact";
import AvailabilityCalendar from "./components/AvailabilityCalendar";
import Footer from "./components/Footer";

function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export default function Home() {
  return (
    <div className="min-h-screen font-sans" style={{ backgroundColor: "#F0EBE0", color: "#3C3530" }}>
      <Navbar onNav={scrollToSection} />
      <Hero onNav={scrollToSection} />
      <About />
      <Rooms onBook={() => scrollToSection("booking")} />
      <Amenities />
      <HouseRules />
      <Gallery />
      <Location />
      <AvailabilityCalendar />
      <Contact />
      <Footer onNav={scrollToSection} />
    </div>
  );
}
